////// Lib. //////
//////////////////

import Component from "gia/Component";

///// Util. //////
//////////////////

// ...

///// Init. //////
//////////////////

// import { get_viewportState } from "../../../assets/js/init/init_viewportState";
import init_player from "./init/init_player.js";
import init_slideshow from "./init/init_slideshow.js";

///// Hdls. //////
//////////////////

// import ebh_window_resize from "./ebh/ebh_window_resize.js";

// import stChH_mode from "./stChH/stChH_mode.js";

///// Assets /////
//////////////////

// All video.js option keys passed from PHP are lowercase, so no manual
// extraction is needed — all keys can be auto-extracted from options arg.

const manualOptionKeys = [];

// Default log styles

const defaultLogStyles = {
  default: "#6682d6",
  action: "#c7d0ff",
  event: "#97a5ce",
  warning: "#ffaf00",
  error: "#ff3232",
  success: "#00c853",
};

// Comp. class ///
//////////////////

export default class VideoPlayer extends Component {
  /////////// Constructor ////////////
  ////////////////////////////////////

  constructor(el, options) {
    super(el);

    //// DOM references ////
    ////////////////////////

    this.ref = {
      videoEl: null,
      slideshowEl: null,
      slideEl: [],
    };

    /////// Options ////////
    ////////////////////////

    // Get options not to be manually extracted from the options arg...
    const autoOptions = {};
    for (const key in options) if (!manualOptionKeys.includes(key)) autoOptions[key] = options[key];

    this.options = {
      name: "VideoPlayer",
      autoplay: false,
      muted: false,
      loop: false,
      controls: true,
      preload: "auto",
      slideDuration: 4000,
      ...autoOptions,
      logs: false,
      logStyles: defaultLogStyles,
    };

    ////// Utilities ///////
    ////////////////////////

    // ...

    /////// Modules ////////
    ////////////////////////

    this.modules = {
      // ...
    };

    ///////// API //////////
    ////////////////////////

    this.api = {
      play: () => this.player?.play(),
      pause: () => this.player?.pause(),
      src: (src, type) => this.player?.src({ src, type }),
      mute: () => this.player?.muted(true),
      unmute: () => this.player?.muted(false),
    };

    // Eventbus listeners //
    ////////////////////////

    // this.ebl_window_resize = ebh_window_resize.bind(this); // NOT NEEDED ATM

    /// State.-ch. list. ///
    ////////////////////////

    // this.stChL_mode = stChH_mode.bind(this); // NOT NEEDED ATM

    /// Pre-mount init. ////
    ////////////////////////

    this.player = null;
    this.slideshow = null;
  }
  ////////////////////////////////////

  mount() {
    if (this.options.logs) console.warn("Mounting:", this.options.name);
    this.init();
  }

  ///////////// Unmount //////////////
  ////////////////////////////////////

  unmount() {
    if (this.options.logs) console.warn("Unmounting:", this.options.name);
    this.destroy_slideshow?.();
    this.destroy_player();
  }

  ////////////// Init. ///////////////
  ////////////////////////////////////

  ////// Base init. //////
  ////////////////////////

  init() {
    this.setState({ mode: "init" });
    this.init_player();
    this.init_slideshow();
    this.setState({ mode: "ready" });
  }

  ///// Player init. /////
  ////////////////////////

  init_player() {
    init_player.call(this);
  }

  // Slideshow fallback //
  ////////////////////////

  init_slideshow() {
    init_slideshow.call(this);
  }

  //// Autoplay with interaction fallback ////
  ////////////////////////////////////////////

  attempt_autoplay() {
    // Ensure muted is set as a DOM property — some browsers (Safari) reset it.
    this.player.muted(true);

    const playPromise = this.player.play();
    if (!(playPromise instanceof Promise)) return;

    playPromise.catch((err) => {
      if (err.name !== "NotAllowedError") return; // unexpected error, ignore

      // Safari (and other browsers) block autoplay until the user has interacted
      // with the page. Defer to the first interaction then retry silently.
      if (this.options.logs) console.log(this.options.name, "autoplay blocked — waiting for first interaction");

      const onInteraction = () => {
        this.player.muted(true);
        this.player.play().catch(() => {}); // best-effort, ignore second failure
      };

      document.addEventListener("click", onInteraction, { once: true, passive: true });
      document.addEventListener("touchstart", onInteraction, { once: true, passive: true });
      document.addEventListener("keydown", onInteraction, { once: true, passive: true });
    });
  }

  // Player destroy. //
  /////////////////////

  destroy_player() {
    if (this.player && !this.player.isDisposed()) {
      this.player.dispose();
      this.player = null;
    }
  }

  /////////// State mgmt. ////////////
  ////////////////////////////////////

  stateChange(changes) {
    if (this.options.logs) console.log("State change:", changes);
    // if ("mode" in changes) this.stChL_mode(changes);
  }
}
